import { InjectionToken } from '@angular/core';

import { Gtag } from './gtag.interface';

export const GTAG = new InjectionToken<Gtag>('gtag');
